'use strict'
class CierreController{
	constructor(helpLang,Usuarios,Proyecto,DataService,Message,Storage,Modal){
		'ngInject';
		this.helpLang = helpLang;
		this.Usuarios = Usuarios;
		this.Proyecto = Proyecto;
		this.DataService = DataService;
		this.Message = Message;
		this.Storage = Storage;
		this.Modal = Modal;
	}
	$onInit(){
		this.items = [
			{value: 1, text: 'Cierre'},
			// {value: 2, text: 'Final'}
		];
		this.mensajeAyuda = 'Hola mundo!...'
		this.usuario = this.Storage.getUser();
		
		setTimeout(()=>{
			// por defecto se asignara la fecha del ultimo desembolso
			// this.proyecto.cierre.fecha_inicio = this.proyecto.cronograma_desembolsos.fecha_3;
			this.archivos = {
				urlDocIT: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/IT` : '',
				urlDocITDescarga: this.proyecto ? `proyectos/${this.proyecto.id_proyecto}/doc/IT/descargar` : ''
			};
			this.DataService.get(`proyectos/${this.proyecto.id_proyecto}/usuarios`)
			.then(response => {
				if (response) {
					this.usuariosParaAsignar = [];
					for(let i in response.datos) {
						response.datos[i].nom = response.datos[i].nombre.split("(")[0]
						this.usuariosParaAsignar.push(response.datos[i]);

						// if (response.datos[i].id_usuario==this.proyecto.fid_usuario_asignado && response.datos[i].id_rol==this.proyecto.fid_usuario_asignado_rol) {
						// 	this.usuario_asignado = this.usuariosParaAsignar[i];
						// }
					}
				}
			})
			this.calcularPlazos();
		},2000)
		
	}


	addIc(value){
		
		if (!value) {
			value=[];
		}
		for(let i in value){
			// console.log(value[i].id_avance_fisico,"<<")
			if (!value[i].id_inspeccion_campo || value[i].edicion) {
				// console.log(value[i].id_avance_fisico, value[i].edicion)
				this.Message.warning(`Debe guardar el registro antes de crear otro`);
				return;
			}
		}
		value.push({edicion: true})
		

	}

	eliminarInspeccion(value,index){
		// Elimina la inspeccion de campo
		if (!value.id_inspeccion_campo) {
		this.proyecto.cierre.inspeccion_campo.splice(index, 1);
		return;
		}
	}
	guardarInspeccion(value,index){
		// Guardar inspeccion de campo
		value.objeto_id= this.proyecto.cierre.id_cierre;
		value.id_proyecto = this.proyecto.id_proyecto;
		value.cant_inspec = this.proyecto.cierre.inspeccion_campo.length;
		value.tipo_inspeccion = 'cierre';
		if (!this.sonDatosValidosInspeccion(index)) {
			return;
		}
		this.DataService.post(`proyectos/inspeccion`,value)
			.then(response=>{
				if (response) {
					// console.log(response)
					value.id_inspeccion_campo= response.datos.id_inspeccion_campo;
					value.fecha = response.datos.fecha;
					value.doc_informe = response.datos.doc_informe;
					value.detalle = response.datos.detalle;
					value.tecnico_inspeccion = response.datos.tecnico_inspeccion;
					this.Message.success("guardado correctamente.");
				}
			})
		value.edicion = false;
	}

	obtenerInspeccion(value){
		if (!value) {
			this.Message.warning(`No se encontro el documento`);
			return;
		}
		let exreg = /\[(.*?)\]\s*(.*)/;
		let codigo = value.split(exreg)[1];
		this.Modal.showDocumentBase64(`proyectos/${this.proyecto.id_proyecto}/doc/${codigo}`,value);
	}
	

	guardarDatosCierre(){
		// console.log(this.proyecto)

		// this.datos = {
		// 	fid_proyecto: this.proyecto.id_proyecto,
		// 	plazo_cierre: this.proyecto.cierre.plazo_cierre,
		// 	_usuario_creacion: this.usuario.id_usuario
		// };

		this.DataService.post(`proyectos/cie`, this.proyecto)
			.then(response=>{
				if(response){
					this.Message.success("Proyecto actualizado correctamente.");
					//this.proyecto.seguimiento = response.datos
					// console.log("datos recibidos despues de guardar: ",this.proyecto)
					
					this.Loading.hide();
					//this.$state.reload();			
				}
			})
	}


	sonDatosValidosInspeccion(posicion) {
		// Validar avance fisico
		
		const FORM = angular.element(document.querySelector(`[name=form_inspeccion_c`)).scope()['form_inspeccion_c'];
		
		let esValido = (
			FORM['fecha_inspeccion_'+posicion].$valid &&
			FORM['listaTecnico_'+posicion].$valid &&
			FORM['detalle_inf_'+posicion].$valid
		);
		
		if (!esValido) {
			
			FORM['fecha_inspeccion_'+posicion].$setTouched();
			FORM['listaTecnico_'+posicion].$setTouched();
			FORM['detalle_inf_'+posicion].$setTouched();

			this.Message.warning('Verifique, corrija y/o llene los campos resaltados.');
			return false;
		}
		return true;
	}

	// funcion para calcular plazos en la etapa de cierre

	calcularPlazos(){
		// console.log("SE EJECUTA LA FUNCION CALCULAR PLAZOS")
		this.plazo_cierre = new Date(this.proyecto.cierre.fecha_inicio);
		this.plazo_cierre.setDate(this.plazo_cierre.getDate() + parseInt(this.proyecto.cierre.plazo_cierre))
		this.plazo_cierre = this.plazo_cierre.toISOString();
	}
		
	
}

export default CierreController;


// WEBPACK FOOTER //
// ./src/app/components/reg-proyectos/c-proyectos/cierre/cierre.controller.js